import { render, staticRenderFns } from "./XmSmallPreview.vue?vue&type=template&id=0a3c1260&scoped=true"
import script from "./XmSmallPreview.vue?vue&type=script&lang=js"
export * from "./XmSmallPreview.vue?vue&type=script&lang=js"
import style0 from "./XmSmallPreview.vue?vue&type=style&index=0&id=0a3c1260&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a3c1260",
  null
  
)

export default component.exports